import React from 'react';
import PropTypes from 'prop-types';

import LoadingModal from 'components/LoadingModal';

const Modal = ({ isExporting, resource, cancelExport }) => (
  <LoadingModal
    description="Your data is being exported now. When the export is complete, the download will start automatically."
    isLoading={isExporting}
    isOpen={isExporting}
    title={`${resource} Export Started`}
    onCancel={cancelExport}
  />
);

Modal.propTypes = {
  cancelExport: PropTypes.func.isRequired,
  isExporting: PropTypes.bool.isRequired,
  resource: PropTypes.string.isRequired,
};

export const withExportingModal = resource => Component => props =>
  React.cloneElement(
    <React.Fragment>
      <Component {...props} />

      <LoadingModal
        description="Your data is being exported now. When the export is complete, the download will start automatically."
        isLoading={props.isExporting}
        isOpen={props.isExporting}
        title={`${resource} Export Started`}
        onCancel={props.cancelExport}
      />
    </React.Fragment>,
    props,
  );

export default Modal;
